"use client";

import { Core } from "@faire/design-tokens";
import { Caution } from "@faire/slate/icons/Caution";
import { Column } from "@faire/web/slate/Layout";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

export const TileGridError: React.FC = () => {
  return (
    <Column className="border-core-border-muted mx-0 my-12 items-center justify-center gap-4 border border-solid px-6 py-12">
      <Caution color={Core.icon.subdued} fontSize="24px" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="An error has occurred, please try again."
          description={{
            text: "error message on search/discover and explore page when network failed",
          }}
        />
      </Typography>
    </Column>
  );
};
